@if ((showProducts$ | async) && filteredProducts.length) {
  <div [id]="slice.sectionId" class="margin-on-scroll">
    <div class="container">
      <!-- length is 9 if there is no title -->
      @if (slice.title.length !== 9) {
        <ngx-dynamic-hooks
          data-source="prismic"
          class="mx-4 text-center py-3 text-color-title"
          [content]="slice.title"
          [options]="{ sanitize: false }"
        >
        </ngx-dynamic-hooks>
      }
      @if (filteredFilterTabs.length > 1 && slice.tabs === true) {
        <div
          class="bg-[--color-gray-5] border border-[--color-gray-4] divide-x divide-[--color-gray-4] flex rounded-2xl justify-center max-w-xl mx-6 md:mx-auto mt-4 lg:mt-0 h-20"
          data-testid="products-tab"
        >
          @for (filter of filteredFilterTabs; track filter; let first = $first; let last = $last) {
            <button
              class="text-gray-2 font-bold flex flex-1 flex-col lg:flex-row justify-center items-center text-sm lg:text-lg"
              [class.rounded-l-2xl]="first"
              [class.rounded-r-2xl]="last"
              [ngClass]="{ 'bg-white text-primary shadow-tab': isActive(filter) }"
              (click)="onProductFilter(filter)"
            >
              <lib-svg class="normal p-1.5 [&_svg]:fill-current" [svg]="filter.iconName"></lib-svg>
              <span>
                {{ filter.prismicTitle || ([filter.translationKey] | translate) }}
              </span>
            </button>
          }
        </div>
      }
      @if (filteredProducts.length) {
        <lib-swiper class="py-4" [index]="initialSlideIndex">
          @for (productItem of filteredProducts; track productItem) {
            <lib-product-box [productItem]="productItem" *libSwiperItem> </lib-product-box>
          }
        </lib-swiper>
      }
    </div>
  </div>
}
